import ViewBase from "../framework/core/mvvm/view_base";
import ModuleManager from "../framework/core/module_manager";

// protected onFocusInEditor(): void;		
// protected onLostFocusInEditor(): void;		
// /**
// !#en Called to initialize the component or node’s properties when adding the component the first time or when the Reset command is used. This function is only called in editor.
// !#zh 用来初始化组件或节点的一些属性，当该组件被第一次添加到节点上或用户点击了它的 Reset 菜单时调用。这个回调只会在编辑器下调用。 
// */
// protected resetInEditor(): void;		


const { ccclass, menu, property, executeInEditMode, inspector } = cc._decorator;

@ccclass
@menu('UI/UButton')
export default class UButton extends cc.Component {
    private _init : boolean

    @property(ViewBase)
    viewBase: ViewBase = null;

    @property
    customEventData : string = "";

    // private targetComponent : cc.Button

    onEnable() {
        if (!this._init) {
            this._init = true
            // this.targetComponent = this.getComponent<cc.Button>(cc.Button)
            if (this.viewBase) {
                this.viewBase.cacheComponent(this.node.name, this)
            }
            this.node.on("click", () => { 
                if (CC_PREVIEW) {
                    let targetComponent = this.getComponent<cc.Button>(cc.Button)
                    if (targetComponent.transition == cc.Button.Transition.SCALE && targetComponent.zoomScale > 1.01) {
                        cc.error(this.viewBase ? this.viewBase.node.name : "", this.node.name, "(Button的ZoomScale效果设置错误，应该为按下缩小、松开变大，请统一设置为0.92)")
                        ModuleManager.instance.toast(`${this.viewBase ? this.viewBase.node.name : ""} ${this.node.name} \n(Button的ZoomScale效果设置错误，应该为按下缩小、松开变大，请统一设置为0.92)`)
                    }
                }
                this.viewBase.buttonClick(this.node, this.customEventData);
            }, this)
        }
    }   

    public onChangeLanguage() {

    }

    protected onFocusInEditor() {
        this.resetInEditor()
    }
 
    protected resetInEditor() {
        let targetComponent = this.getComponent<cc.Button>(cc.Button)
        if (targetComponent.zoomScale > 1.01) {
            targetComponent.zoomScale = 0.92
            // cc.error("Button的ZoomScale设置错误，请统一设置成0.92")
        }
        if (this.viewBase == null) {
            let parent = this.node
            while (parent != null) {
                this.viewBase = parent.getComponent<ViewBase>(ViewBase)
                if (this.viewBase != null) {
                    break;
                }
                parent = parent.parent
            }
        }
    }
}
